import Input from "../input";
import Button from "..//button";
import { useState, useEffect, useMemo } from "react";
import { doc, setDoc } from "firebase/firestore";
import { db } from "src/firebase/firebase";
import Select from "../../components/select/select";
import { Formik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import Modal from "../../components/ui/modal";
import "react-medium-image-zoom/dist/styles.css";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import DateTimePicker from "react-datetime-picker";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import ReactPanZoom from "react-image-pan-zoom-rotate";
import ImagePicker from "../../components/ui/imagePicker";
import Resizer from "react-image-file-resizer";
import { isArray } from "lodash";
import Loader from "../../components/loader";
const filterOptions = [
  {
    value: "pending",
    label: "Pending",
  },
  {
    value: "paid",
    label: "Accepted",
  },

  {
    value: "declined",
    label: "Declined",
  },
  {
    value: "pending activation",
    label: "Pending activation",
  },
];
const activationTimerOptions = [
  {
    value: 0,
    label: 0,
  },
  {
    value: 1,
    label: 1,
  },
  {
    value: 2,
    label: 2,
  },
  {
    value: 3,
    label: 3,
  },
  {
    value: 4,
    label: 4,
  },
  {
    value: 5,
    label: 5,
  },
  {
    value: 6,
    label: 6,
  },
  {
    value: 7,
    label: 7,
  },
  {
    value: 8,
    label: 8,
  },
  {
    value: 9,
    label: 9,
  },
  {
    value: 10,
    label: 10,
  },
  {
    value: 11,
    label: 11,
  },
  {
    value: 12,
    label: 12,
  },
  {
    value: 13,
    label: 13,
  },
  {
    value: 14,
    label: 14,
  },
  {
    value: 15,
    label: 15,
  },

  {
    value: 16,
    label: 16,
  },
  {
    value: 17,
    label: 17,
  },
  {
    value: 18,
    label: 18,
  },
  {
    value: 19,
    label: 19,
  },
  {
    value: 20,
    label: 20,
  },
  {
    value: 21,
    label: 21,
  },
  {
    value: 22,
    label: 22,
  },
  {
    value: 23,
    label: 23,
  },
  {
    value: 24,
    label: 24,
  },
  {
    value: 25,
    label: 25,
  },
  {
    value: 26,
    label: 26,
  },
  {
    value: 27,
    label: 27,
  },
  {
    value: 28,
    label: 28,
  },
  {
    value: 29,
    label: 29,
  },
  {
    value: 29,
    label: 29,
  },
  {
    value: 30,
    label: 30,
  },

  {
    value: 31,
    label: 31,
  },
  {
    value: 32,
    label: 32,
  },
  {
    value: 33,
    label: 33,
  },
  {
    value: 34,
    label: 34,
  },
  {
    value: 35,
    label: 35,
  },
  {
    value: 36,
    label: 36,
  },
  {
    value: 37,
    label: 37,
  },
  {
    value: 38,
    label: 38,
  },
  {
    value: 39,
    label: 39,
  },
  {
    value: 40,
    label: 40,
  },
  {
    value: 41,
    label: 41,
  },
  {
    value: 42,
    label: 42,
  },
  {
    value: 43,
    label: 43,
  },
  {
    value: 44,
    label: 44,
  },
  {
    value: 45,
    label: 45,
  },
  {
    value: 46,
    label: 46,
  },
  {
    value: 47,
    label: 47,
  },
  {
    value: 48,
    label: 48,
  },
  {
    value: 49,
    label: 49,
  },
  {
    value: 50,
    label: 50,
  },
  {
    value: 51,
    label: 51,
  },
  {
    value: 52,
    label: 52,
  },
  {
    value: 53,
    label: 53,
  },
  {
    value: 54,
    label: 54,
  },
  {
    value: 55,
    label: 55,
  },
  {
    value: 56,
    label: 56,
  },
  {
    value: 57,
    label: 57,
  },
  {
    value: 58,
    label: 58,
  },
  {
    value: 59,
    label: 59,
  },
  {
    value: 60,
    label: 60,
  },
];

const validationSchema = Yup.object().shape({
  order: Yup.string().required("Order is required"),
  status: Yup.string().required("Status is required"),
  note: Yup.string().required("Note is required"),

  rate: Yup.number()
    .required("Rate is required.")
    .typeError("Accept only number"),
  date: Yup.date(),
  declinedImages: Yup.array(),
  activationTime: Yup.string().required("Activation time is required"),
});

const initialValues = {
  order: "",
  status: "",
  rate: "",
  note: "",
  declinedImages: [],
  activationTime: "",
};

const storage = getStorage();

const CardDetail = ({
  detail,
  isProcessingTeam = false,
  closePopup,
  isAdmin = false,
}: any) => {
  console.log("activeCardDetail", detail);
  const [frontImageProgress, setFrontImageProgress] = useState(0);

  const [frontImageLoading, setFrontImageLoading] = useState<boolean>(false);
  const cardImages = useMemo(() => {
    let _images = [];
    if (detail?.images?.length > 0) {
      _images = detail.images;
    } else {
      detail?.frontImage && _images.push(detail.frontImage);
      detail?.backImage && _images.push(detail.backImage);
      detail?.receiptImage && _images.push(detail.receiptImage);
    }
    return _images ?? [];
  }, [detail]);

  const initValue = useMemo(() => {
    let _detail = detail?.order
      ? {
          order: detail?.order,
          status: detail?.status,
          rate: detail?.rate ? detail.rage : detail?.offering?.rate,
          note: detail?.note,
          declinedImages: detail?.declinedImages ?? [],
          activationTime: detail?.activationTime,
        }
      : {
          ...initialValues,
          rate: detail?.rate ? detail.rage : detail?.offering?.rate,
        };
    return _detail;
  }, [detail]);

  console.log("initValue", initValue);
  const { t } = useTranslation(["home"]);
  const [isLoading, setIsLoading] = useState(false);
  const [zoomImage, setZoomImage] = useState<number>(-1);

  const handleOrder = async (values: any) => {
    const _detail = detail;
    _detail.order = values.order;
    _detail.status = values.status;
    _detail.payoutStatus =
      values.status === "paid" ? "pending" : _detail?.payoutStatus ?? "";
    _detail.rate = values.rate;
    _detail.note = values.note;
    _detail.transectionDate = new Date();

    let _time = values.activationTime ? (values.activationTime as number) : 0;

    _detail.activationTime = new Date().setSeconds(
      new Date().getSeconds() + _time * 60
    );

    _detail.declinedImages = values.declinedImages ?? [];

    setIsLoading(true);
    await setDoc(doc(db, "Cards", _detail.id), _detail);
    setIsLoading(false);
    closePopup?.();
  };

  const handleDownload = (index: number) => {
    setZoomImage(index);
  };
  const getImage = async (file: any) => {
    const _image = await new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1500,
        1500,
        "JPEG",
        90,
        0,
        (uri) => {
          let _url: any = uri;
          _url.name = `images-${new Date().getTime()}`;
          resolve(_url);

          // setTimeout(() => {
          //   setCompressImages([...compressImages, uri]);
          // }, 100);
        },
        "blob",
        400,
        400
      );
    });

    return _image;
  };

  const getCompressImages = async (files: any) => {
    try {
      let promises = files.map(async (file) => {
        let _image = await getImage(file);
        return _image;
      });
      const results = await Promise.all(promises);
      return results;
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="bg-white  rounded ">
      <h3 className=" border-b font-bold border-b py-3 pl-3 ">
        {t("View Card")}
      </h3>
      <div className="flex border-r">
        <div className="py-3 w-2/3">
          <div className="border-b p-4 pb-24">
            <div className="flex">
              <Card name={t("Card No")} value={detail?.cardNo} />
              <Card name={t("MM/YY")} value={detail?.mmyy} />
              <Card name={t("Cvv")} value={detail?.cvv} />
              <Card name={t("Amount")} value={detail?.amount} />
              {isProcessingTeam && (
                <Card
                  name={t("User Name")}
                  value={
                    detail?.account?.firstName + " " + detail?.account?.lastName
                  }
                />
              )}
              {!isProcessingTeam && (
                <>
                  <Card name={t("Rate")} value={detail?.rate} />
                </>
              )}
              <Card
                name={t("Date")}
                value={
                  detail?.date
                    ? new Date(detail?.date.seconds * 1000).toDateString()
                    : ""
                }
              />
            </div>
            <div className="flex mt-4">
              <Card name={t("Note")} value={detail?.note} />
            </div>
            {(isProcessingTeam || isAdmin) && (
              <div className="flex gap-x-2 mt-5">
                <Formik
                  enableReinitialize
                  initialValues={initValue}
                  validationSchema={validationSchema}
                  onSubmit={handleOrder}
                  validateOnBlur
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleSubmit,
                    setFieldTouched,
                    setFieldValue,
                    handleBlur,
                    handleChange,
                    isSubmitting,
                  }) => {
                    const uploadImage = async (files: any) => {
                      let _comressFiles = await getCompressImages(files);

                      _comressFiles.forEach(async (file) => {
                        const storageRef = ref(storage, file.name);
                        const uploadTask = uploadBytesResumable(
                          storageRef,
                          file
                        );
                        uploadTask.on(
                          "state_changed",
                          (snapshot) => {
                            const progress =
                              (snapshot.bytesTransferred /
                                snapshot.totalBytes) *
                              100;

                            setFrontImageProgress(progress);
                            if (progress === 100) {
                              setFrontImageLoading(false);
                            } else {
                              setFrontImageLoading(true);
                            }

                            switch (snapshot.state) {
                              case "paused":
                                console.log("Upload paused");
                                break;
                              case "running":
                                console.log("Upload running", progress);
                                break;
                              default:
                                break;
                            }
                          },
                          (error) => {
                            console.log(error);
                          },
                          () => {
                            getDownloadURL(uploadTask.snapshot.ref).then(
                              async (downloadedURL) => {
                                let _images = values.declinedImages;

                                _images.push(downloadedURL);

                                await setFieldValue("declinedImages", _images);
                                setFieldTouched("declinedImages", true);
                              }
                            );
                          }
                        );
                        // uploadBytes(storageRef, file).then((snapshot) => {
                        //   console.log("Uploaded a blob or file!");
                        //   console.log(snapshot);
                        // });
                        // console.log("@@@@@@");
                        // const path = `/images/${file.name}`;
                        // const ref = storage.ref(path);
                        // await ref.put(file);
                        // const url = await ref.getDownloadURL();
                        // console.log("url:", url);

                        // var reader = new FileReader();
                        // reader.onloadend = function () {
                        //   setFieldTouched(fieldName, true);
                        //   setFieldValue(fieldName, reader.result);
                        // };
                        // reader.readAsDataURL(file);
                      });
                    };

                    console.log("values", values);

                    return (
                      <form
                        onSubmit={handleSubmit}
                        className=" bg-white-100 p-5 rounded"
                      >
                        <div className="flex flex-wrap gap-4 items-center">
                          <Input
                            name="order"
                            label={t("Order")}
                            containerClass="w-full"
                            placeholder={t("Order")}
                            error={errors.order}
                            touched={errors.order}
                            inputClassName="!bg-white"
                            onChange={handleChange}
                            value={values.order}
                            onBlur={handleBlur}
                            variant="solid"
                          />
                          <Input
                            name="rate"
                            label={t("Rate")}
                            value={values.rate}
                            containerClass="w-full"
                            placeholder={t("Rate")}
                            error={errors.rate}
                            touched={errors.rate}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            inputClassName="!bg-white"
                            variant="solid"
                          />
                        </div>
                        <div>
                          <label className="mb-2 text-sm font-semibold inline-block">
                            {t("Status")}
                          </label>
                          <Select
                            options={filterOptions}
                            placeholder={
                              values.status ? values.status : "Select status"
                            }
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) =>
                                ({ ...base, zIndex: 9999 } as any),
                            }}
                            onChange={(value: any) => {
                              setFieldTouched("status", true);
                              setFieldValue("status", value.value);
                            }}
                          />
                          {touched.status && errors.status && (
                            <p className="my-2 text-xs text-start text-red">
                              {errors.status as string}
                            </p>
                          )}
                        </div>
                        <div>
                          <Input
                            name="note"
                            label={t("Note")}
                            containerClass="w-full"
                            placeholder={t("Note")}
                            value={values.note}
                            error={errors.note}
                            touched={errors.note}
                            onChange={handleChange}
                            inputClassName="!bg-white"
                            onBlur={handleBlur}
                            variant="solid"
                          />
                        </div>

                        <div className="mb-3 mt-3+">
                          <label className="mb-2 text-sm font-semibold inline-block">
                            {t("Activation time ( in minutes)")}
                          </label>
                          <Select
                            options={activationTimerOptions}
                            placeholder={"Select activation time"}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) =>
                                ({
                                  ...base,
                                  zIndex: 9999,
                                } as any),
                            }}
                            onChange={(value: any) => {
                              setFieldTouched("activationTime", true);
                              setFieldValue("activationTime", value.value);
                            }}
                          />
                          {touched.activationTime && errors.activationTime && (
                            <p className="my-2 text-xs text-start text-red">
                              {errors.activationTime as string}
                            </p>
                          )}
                        </div>

                        <div className="mt-3">
                          <ImagePicker
                            className="flex-1"
                            title="Upload image for declined evidence etc."
                            error={errors.declinedImages as string}
                            value={values.declinedImages ?? []}
                            touched={touched.declinedImages as boolean}
                            resetValue={() => {
                              setFieldValue("declinedImages", []);
                            }}
                            onChange={(files) => uploadImage(files)}
                          />
                          <div className="flex items-center justify-start w-fit gap-6 text-blue">
                            {frontImageLoading && <Loader />}{" "}
                            {frontImageProgress > 0 &&
                              frontImageLoading &&
                              frontImageProgress.toFixed() + "%"}
                          </div>
                        </div>
                        <div className="mt-3">
                          <Button
                            size="medium"
                            className="ml-0 block bg-blue "
                            loading={isLoading}
                            type="button"
                            onClick={handleSubmit as any}
                          >
                            {detail?.order ? t("Update") : t("Add")}
                          </Button>
                        </div>
                      </form>
                    );
                  }}
                </Formik>
              </div>
            )}
          </div>
        </div>
        <div className="flex flex-col gap-6 py-4 px-4">
          {cardImages?.map((image, index) => (
            <div className="relative group h-[200px] w-[350px]">
              {/* <span className="font-bold">{t("Card Front Image")}</span> */}
              <div className="absolute h-full w-full bg-stone-500/75 flex justify-center items-center group-hover:flex hidden">
                <Button onClick={() => handleDownload(index)}>
                  {t("View")}
                </Button>
              </div>

              <a download="image.png" href="/path/to/image" title="ImageName">
                <img
                  alt=""
                  className="h-[200px] w-[350px] object-cover"
                  src={image ?? ""}
                />
              </a>
            </div>
          ))}
        </div>
        {/* <div className="py-3 w-1/3 border-l px-10 relative group cursor-pointer">
          <span className="font-bold">{t("Receipt Image")}</span>
          <div className="absolute h-full w-full bg-stone-500/75 flex justify-center items-center group-hover:flex hidden">
            <Button onClick={() => handleDownload(2)}>{t("View")}</Button>
          </div>
          <img
            alt=""
            className="w-full max-h-[500px]"
            src={detail?.receiptImage ?? ""}
          />
        </div> */}
        <Modal
          open={zoomImage > -1 ? true : false}
          onClose={() => setZoomImage(-1)}
        >
          <div className="bg-white p-10 ">
            <Carousel selectedItem={zoomImage} showThumbs={false}>
              {cardImages.map((image) => (
                <div
                  className="h-[90vh] mx-auto object-cover"
                  style={{
                    width: 500,
                    height: 500,
                  }}
                >
                  <ReactPanZoom image={image} />
                </div>
              ))}
            </Carousel>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default CardDetail;

const Card = ({ name, value }) => {
  return (
    <div className="flex flex-col w-[16.6%]">
      <span className="font-bold">{name}</span>
      <span className="text-grey text-sm">{value}</span>
    </div>
  );
};
